import { ServiceContainer } from '@tv2-player/service-container/src/serviceContainer';
import { devFlags } from '../util/devFlags';

export const prerollOverrideUrls = {
  dev: 'https://vast-api-gateway.pvp-dev.tv2dev.dk/vmap',
  prod: 'https://vast-api-gateway.pvp.tv2api.dk/vmap',
};

export function manipulateAdUrl(url: string) {
  const adUrlReplacementEnabled = ServiceContainer.config.get(devFlags.enablePrerollOverride);
  const apiGateway = ServiceContainer.config.get(devFlags.prerollOverrideUrl);

  if (adUrlReplacementEnabled && url?.includes('pubads.g.doubleclick.net')) {
    return url.replace('https://pubads.g.doubleclick.net', apiGateway);
  }

  return url;
}
